module.exports = __webpack_public_path__ + "img/tips-luggage.0e4a905e.svg";